// @ts-check
// Autoguardado local del editor de Python (TSK-0100, CAP-PYTHON-EDITOR-SHELL,
// MOD-PYTHON-EDITOR).
//
// Adaptador: la lógica vive en `state/algorithm-drafts.js`, compartida con el
// editor de pseudocódigo (`pseudocode-editor/pseudocode-persistence.js`),
// porque los dos archivos eran ~82 % el mismo código. Mismo molde que
// `diagram-editor/attempt-persistence.js` sobre `state/attempt-persistence.js`.
// La API pública de esta feature no cambia: `attempt-panel.js`,
// `pages/python-editor-page.js` y `translation/entrega.js` siguen importando
// exactamente los mismos nombres de aquí.
//
// Alcance explícito y mismo límite duro que antes: persistencia SOLO en
// `localStorage`, SIN cuenta de usuario y SIN llamar a ningún backend
// (AMB-010). Ni este archivo ni el módulo compartido importan
// `services/api-client.js` ni ningún `*-api.js`, ni hacen ninguna llamada
// `fetch`/HTTP.
//
// CLAVE DE ALMACENAMIENTO PROPIA (criterio de aceptación explícito de la
// tarea): namespace `'progedu.python-editor.autoguardado'`, distinto tanto de
// `'progedu.diagram-editor.autoguardado'`
// (`diagram-editor/editor-persistence.js#CLAVE_ALMACENAMIENTO`) como de
// `'progedu.pseudocode-editor.autoguardado'`
// (`pseudocode-persistence.js#CLAVE_ALMACENAMIENTO`). Se declara AQUÍ, como
// literal, y no se compone en el módulo compartido: un literal es lo que
// `tests/unit/state/editor-drafts-namespaces.spec.js` puede encontrar para
// exigir que la limpieza de sesión lo cubra. Cambiarlo un solo byte
// invalidaría los borradores ya guardados en los navegadores de los alumnos.
import { crearPersistenciaAlgoritmos } from '../../state/algorithm-drafts.js';

/** @typedef {import('../../state/algorithm-model.js').Algoritmo} Algoritmo */
/** @typedef {import('../../state/algorithm-drafts.js').EstadoGuardable} EstadoPythonGuardable */
/** @typedef {import('../../state/algorithm-drafts.js').ResultadoGuardado} ResultadoGuardado */

/**
 * Clave de almacenamiento propia de esta feature (ver cabecera del archivo:
 * namespace exclusivo, sin colisión con `diagram-editor` ni con
 * `pseudocode-editor`).
 */
export const CLAVE_ALMACENAMIENTO = 'progedu.python-editor.autoguardado';

export { VERSION_ESQUEMA, LIMITE_BYTES } from '../../state/algorithm-drafts.js';

const almacen = crearPersistenciaAlgoritmos({
  claveAlmacenamiento: CLAVE_ALMACENAMIENTO,
  claveSonda: '__progedu_python_editor_probe__',
  nombreFuncionGuardar: 'guardarEstadoPythonLocal',
});

export const { esAlmacenamientoDisponible } = almacen;
export const guardarEstadoPythonLocal = almacen.guardarEstado;
export const cargarEstadoPythonLocal = almacen.cargarEstado;
export const limpiarEstadoPythonLocal = almacen.limpiarEstado;
export const crearAutoguardadoPythonLocal = almacen.crearAutoguardado;
